import { combineReducers } from 'redux';

import { ACTIONS as activityAddCardAction } from 'actions/activities-add-card';
import { ACTIONS as activityAggregation } from 'actions/activity-aggregation';
import { ACTIONS as addHealthCheckData } from 'actions/add-health-check-data';
import { ACTIONS as addonsActions } from 'actions/addons';
import { ACTIONS as blockContent } from 'actions/block-contents';
import { ACTIONS as blocks } from 'actions/block';
import { ACTIONS as bulkUpdateActions } from 'actions/curriculum-bulk-update';
import { ACTIONS as chapterAnalytics } from 'actions/chapter-analytics';
import { ACTIONS as chapterContent } from 'actions/chapter-contents';
import { ACTIONS as chapters } from 'actions/chapters';
import { ACTIONS as classroomAnalytics } from 'actions/classroom-analytics';
import { ACTIONS as configActions } from 'actions/configs';
import { ACTIONS as courseClassLogActions } from 'actions/course-class-log';
import { ACTIONS as courseListActions } from 'actions/course-list';
import { ACTIONS as credListActions } from 'actions/creds';
import { ACTIONS as curriculumAddSheetActions } from 'actions/curriculum-add-sheet';
import { ACTIONS as curriculumSearchActions } from 'actions/curriculum-search';
import { ACTIONS as curriculumTagsActions } from 'actions/curriculum-tags';
import { ACTIONS as demoClassroomActions } from 'actions/demo-classroom';
import { ACTIONS as demoSlots } from 'actions/demo-slots-create';
import { ACTIONS as discountActions } from 'actions/discounts';
import { ACTIONS as drafts } from 'actions/drafts';
import { ACTIONS as executePaymentActions } from 'actions/execute-payment';
import { ACTIONS as foundationPaymentActions } from 'actions/foundation-student-payment-link';
import { ACTIONS as itemResponses } from 'actions/activity-analytics';
import { ACTIONS as learnosityTags } from 'actions/learnosity-tag-data';
import { ACTIONS as listCount } from 'actions/list-count';
import { ACTIONS as login } from 'actions/login';
import { ACTIONS as logout } from 'actions/logout';
import { ACTIONS as nodes } from 'actions/nodes';
import { ACTIONS as offlinePaymentLinkOptions } from 'actions/offline-payment';
import { ACTIONS as parentLeadActions } from 'actions/parent-lead';
import { ACTIONS as parentRMAssignmentActions } from 'actions/bulk-parent-rm-assignment';
import { ACTIONS as parentRMActions } from 'actions/relationship-manager';
import { ACTIONS as parentStudentActions } from 'actions/parent-student';
import { ACTIONS as parentsActions } from 'actions/parents';
import { ACTIONS as phoneUpdateActions } from 'actions/phone-number-update';
import { ACTIONS as preferrenceTeachers } from 'actions/preferrence-teacher-slots';
import { ACTIONS as programAnalytics } from 'actions/program-analytics';
import { ACTIONS as programs } from 'actions/programs';
import { ACTIONS as remedials } from 'actions/remedials';
import { ACTIONS as studentAggregateAnalytics } from 'actions/student-analytics';
import { ACTIONS as studentCourseClassesTransferActions } from 'actions/student-course-classes-transfer';

import { ACTIONS as studentCourseLogActions } from 'actions/student-course-log';
import { ACTIONS as studentCredentialsActions } from 'actions/student-credentials';
import { ACTIONS as studentDemos } from 'actions/student-demos';
import { ACTIONS as studentRegions } from 'actions/student-regions';
import { ACTIONS as studentUniqueSlots } from 'actions/student-unique-slots';
import { ACTIONS as subscriptionPaymentLink } from 'actions/subscription-payment-link';
import { ACTIONS as subscriptionPlans } from 'actions/subscription-plan';
import { ACTIONS as subscriptionProducts } from 'actions/subscription-product';
import { ACTIONS as teacherAggregateAnalytics } from 'actions/teacher-analytics';
import { ACTIONS as teacherClassStatusActions } from 'actions/teacher-class-status';
import { ACTIONS as teacherClassroomList } from 'actions/teacher-classroom-list';
import { ACTIONS as teacherClassrooms } from 'actions/teacher-classrooms';
import { ACTIONS as teacherCredActions } from 'actions/teacher-cred';
import { ACTIONS as teacherDetailsActions } from 'actions/teacher-details';
import { ACTIONS as teacherExportActions } from 'actions/teacher-export';
import { ACTIONS as teacherSlotDataActions } from 'actions/teacher-slot-data';
import { ACTIONS as teacherStudentsActions } from 'actions/teacher-students';
import { ACTIONS as vibesAction } from 'actions/vibes';
import { ACTIONS as teacherMappingActions } from 'actions/teacher-mapping';
import { ACTIONS as studentRevertUpgradePaymentLinkActions } from 'actions/student-revert-upgrade-payment-link';
import { ACTIONS as renewalPlanActions } from 'actions/renewal-plans';
import { ACTIONS as festReports } from 'actions/cuemath-fest-reports';

import RestReducer from './reducer';
import authReducer from './auth';
import demoIncentiveReducer from './demo-incentive';
import modalReducer from './modal';
import NotificationReducer from './notification';
import onlineBandReducer from './online-bands';
import onlinePlanReducer from './online-plan';
import planCoursesReducer from './online-plan-courses';
import pricingReducer from './pricing';
import relationshipManagerReducer from './relationship-manager';
import slotPopupReducer from './slot-popup';
import studentAccountReducer from './student-account';
import studentCourseReducer from './student-course';
import studentCoursesReducer from './student-courses';
import studentDemoListReducer from './student-demo-list';
import studentListReducer from './student-list';
import studentPaymentReducer from './student-payment-links';
import studentProfileReducer from './student-profile';
import studentReducer from './students';
import studentSlotsReducer from './student-slots';
import teacherClassLogsReducer from './teacher-class-logs';
import teacherListReducer from './teacher-list';
import applicantListReducer from './applicant-list';
import applicantDetailReducer from './applicant-detail';
import teacherProfileReducer from './teacher-profile';
import teacherSlotsReducer from './teacher-slots';
import teachersReducer from './teachers';
import studentCourseUpgradeReducer from './student-course-upgrade-reducer';
import studentCourseTrialUpgradeReducer from './student-course-trial-upgrade';
import studentCourseUpgradeV2Reducer from './student-course-upgrade-v2';
import avSessionTokenReducer from './av/av-session-token';
import toastReducer from './toast-msg';
import maintenanceReducer from './maintenance';

export default combineReducers({
  activityAddCard: RestReducer(activityAddCardAction),
  activityList: RestReducer(activityAggregation),
  addonsList: RestReducer(addonsActions),
  avSessionToken: avSessionTokenReducer,
  discountDetails: RestReducer(discountActions),
  auth: authReducer,
  blockContent: RestReducer(blockContent),
  blocks: RestReducer(blocks),
  bulkUpdate: RestReducer(bulkUpdateActions),
  chapterAnalytics: RestReducer(chapterAnalytics),
  chapterContent: RestReducer(chapterContent),
  chapters: RestReducer(chapters),
  classroomAnalytics: RestReducer(classroomAnalytics),
  configs: RestReducer(configActions),
  courseClassLog: RestReducer(courseClassLogActions),
  courseList: RestReducer(courseListActions),
  credList: RestReducer(credListActions),
  curriculumAddSheet: RestReducer(curriculumAddSheetActions),
  curriculumSearch: RestReducer(curriculumSearchActions),
  curriculumTags: RestReducer(curriculumTagsActions),
  demoClassroom: RestReducer(demoClassroomActions),
  demoIncentiveData: demoIncentiveReducer,
  demoSlots: RestReducer(demoSlots),
  drafts: RestReducer(drafts),
  executePayment: RestReducer(executePaymentActions),
  festReports: RestReducer(festReports),
  foundationPayment: RestReducer(foundationPaymentActions),
  healthCheckData: RestReducer(addHealthCheckData),
  itemResponses: RestReducer(itemResponses),
  learnosityTags: RestReducer(learnosityTags),
  listCount: RestReducer(listCount),
  login: RestReducer(login),
  logout: RestReducer(logout),
  maintenance: maintenanceReducer,
  modal: modalReducer,
  nodes: RestReducer(nodes),
  notification: NotificationReducer,
  offlinePaymentLink: RestReducer(offlinePaymentLinkOptions),
  onlineBand: onlineBandReducer,
  onlinePlanList: onlinePlanReducer,
  parentRMAssignment: RestReducer(parentRMAssignmentActions),
  parentRM: RestReducer(parentRMActions),
  parents: RestReducer(parentsActions),
  parentLead: RestReducer(parentLeadActions),
  parentStudentDetails: RestReducer(parentStudentActions),
  parentStudents: RestReducer(parentLeadActions),
  phoneUpdate: RestReducer(phoneUpdateActions),
  planCourses: planCoursesReducer,
  preferrenceTeachers: RestReducer(preferrenceTeachers),
  pricing: pricingReducer,
  programAnalytics: RestReducer(programAnalytics),
  programs: RestReducer(programs),
  relationshipManagers: relationshipManagerReducer,
  remedials: RestReducer(remedials),
  renewalPlans: RestReducer(renewalPlanActions),
  slotPopup: slotPopupReducer,
  studentAccount: studentAccountReducer,
  studentAggregateAnalytics: RestReducer(studentAggregateAnalytics),
  studentCourse: studentCourseReducer,
  studentCourseClassesTransfer: RestReducer(studentCourseClassesTransferActions),

  studentCourseLog: RestReducer(studentCourseLogActions),
  studentCourses: studentCoursesReducer,
  studentCourseUpgrade: studentCourseUpgradeReducer,
  studentCourseTrialUpgrade: studentCourseTrialUpgradeReducer,
  studentCourseUpgradeV2: studentCourseUpgradeV2Reducer,
  studentCredentials: RestReducer(studentCredentialsActions),
  studentDemoList: studentDemoListReducer,
  studentDemos: RestReducer(studentDemos),
  studentList: studentListReducer,
  studentPaymentLink: studentPaymentReducer,
  studentProfile: studentProfileReducer,
  studentRegions: RestReducer(studentRegions),
  students: studentReducer,
  studentSlots: studentSlotsReducer,
  studentUniqueSlots: RestReducer(studentUniqueSlots),
  subscriptionPaymentLink: RestReducer(subscriptionPaymentLink),
  subscriptionPlans: RestReducer(subscriptionPlans),
  subscriptionProducts: RestReducer(subscriptionProducts),
  teacherAggregateAnalytics: RestReducer(teacherAggregateAnalytics),
  teacherClassLogs: teacherClassLogsReducer,
  teacherClassroomList: RestReducer(teacherClassroomList),
  teacherClassrooms: RestReducer(teacherClassrooms),
  teacherCreds: RestReducer(teacherCredActions),
  teacherDetails: RestReducer(teacherDetailsActions),
  teacherExport: RestReducer(teacherExportActions),
  teacherList: teacherListReducer,
  teacherApplicantList: applicantListReducer,
  teacherApplicantDetail: applicantDetailReducer,
  teacherProfile: teacherProfileReducer,
  teachers: teachersReducer,
  teacherSlots: teacherSlotsReducer,
  teacherSlotData: RestReducer(teacherSlotDataActions),
  teacherStudents: RestReducer(teacherStudentsActions),
  teacherMapping: RestReducer(teacherMappingActions),
  toastMessage: toastReducer,
  vibes: RestReducer(vibesAction),
  teacherClassStatus: RestReducer(teacherClassStatusActions),
  studentRevertUpgradePaymentLink: RestReducer(studentRevertUpgradePaymentLinkActions),
});
